import React from 'react'
import styled from 'styled-components'
import { useTransition, animated } from 'react-spring'

import colors from '../../styles/colors'

interface PanelProps {
  show?: boolean
  allowOverflow?: boolean
}
export const Panel: React.FC<PanelProps> = ({
  allowOverflow = false,
  show = true,
  children,
  ...rest
}) => {
  const transitions = useTransition(show, null, {
    from: { transform: 'translate3d(-100%,0,0)' },
    enter: { transform: 'translate3d(0,0,0)' },
    leave: { transform: 'translate3d(-100%,0,0)' },
  })
  return (
    <React.Fragment>
      {transitions.map(
        ({ item, key, props: animatedProps }) =>
          item && (
            <StyledPanel
              data-testid="panel"
              key={key}
              style={{
                ...animatedProps,
                overflowY: allowOverflow ? 'scroll' : 'hidden',
              }}
              {...rest}
            >
              {children}
            </StyledPanel>
          )
      )}
    </React.Fragment>
  )
}

const StyledPanel = styled(animated.div)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  padding: 2rem;
  background: ${colors.white};
  border-left: 1px solid ${colors.grey};
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
`
